<h2 mat-dialog-title>Detalhes</h2>
<mat-dialog-content>{{ data.summary }}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>